/**
 * AJAX add-to-cart for furlouve-product-card.liquid. Delegated on document
 * (not per-card) so it keeps working for cards added later — e.g. a tab
 * switch re-rendering the grid.
 *
 * Reuses the theme's own cart event bus (@theme/events) rather than
 * inventing a parallel one, so any current or future component listening
 * for cart:update (like the header's cart badge) stays in sync regardless
 * of what actually triggered the change.
 */
import { CartUpdateEvent, CartErrorEvent } from '@theme/events';

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-flv-product-form]')) return;

  event.preventDefault();

  const button = /** @type {HTMLButtonElement | null} */ (form.querySelector('.flv-product-card__add'));
  const label = form.querySelector('[data-flv-add-label]');
  if (!button || !label || button.disabled) return;

  const productId = form.dataset.productId ?? '';
  const originalText = label.textContent;
  button.disabled = true;
  label.textContent = 'Adding…';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.description || result.message || 'Add to cart failed');
    }

    const cart = await fetch('/cart.js').then((res) => res.json());

    document.dispatchEvent(
      new CartUpdateEvent(cart, productId, {
        source: 'furlouve-product-card',
        productId,
        itemCount: cart.item_count,
        variantId: result.variant_id,
      })
    );

    label.textContent = 'Added!';
  } catch (error) {
    label.textContent = 'Try again';
    document.dispatchEvent(
      new CartErrorEvent(productId, error instanceof Error ? error.message : 'Add to cart failed', {}, {})
    );
  } finally {
    setTimeout(() => {
      label.textContent = originalText;
      button.disabled = false;
    }, 1400);
  }
});
